
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';


function Aluminiuamlmosquito() {



  const cardData =
  {
    keyword: ' Aluminium Mosquito Net ',
    heading: 'Anjali Enterprises: Aluminium Mosquito Net',
    headingDescription: 'Anjali Enterprises provides premium aluminium mosquito net installation services, offering effective and eco-friendly solutions to keep your space free from pests. Our high-quality aluminium mesh nets are designed to provide long-lasting protection against mosquitoes and other insects while allowing fresh air and light to flow into your home or office. Whether you are looking for custom mosquito nets, eco-friendly options, or durable installations, we offer a wide range of services tailored to meet your needs.',

    "topPlaces": [
    {
      "title": "Aluminium Mosquito Net Installation",
      "description": "We specialize in the professional installation of aluminium mosquito nets for windows and doors. Our team ensures precise fitting and secure installation, providing an effective barrier against mosquitoes while maintaining the aesthetic appeal of your space."
    },
    {
      "title": "Custom Mosquito Nets for Windows",
      "description": "Anjali Enterprises offers custom mosquito nets tailored to the specific dimensions and design of your windows. We ensure a perfect fit, offering optimal protection against mosquitoes without compromising on the look of your windows."
    },
    {
      "title": "Mosquito-Proof Solutions",
      "description": "Our mosquito-proof solutions are designed to keep your space safe from pests. Using high-quality aluminium mesh, our nets allow you to enjoy fresh air without the worry of mosquitoes, offering an effective and durable solution for homes and offices."
    },
    {
      "title": "High-Quality Aluminium Mesh Nets",
      "description": "Our aluminium mesh nets are made from durable, high-quality materials that provide long-lasting protection against mosquitoes and other insects. These nets are designed to be robust, lightweight, and easy to maintain, ensuring their effectiveness for years to come."
    },
    {
      "title": "Best Mosquito Net for Windows",
      "description": "We offer the best mosquito nets for windows, designed to fit a variety of window types and sizes. Our nets are made from premium aluminium mesh, ensuring superior protection and a sleek, modern appearance."
    },
    {
      "title": "Aluminium Mosquito Net for Homes and Offices",
      "description": "Whether for your home or office, we provide high-quality aluminium mosquito nets that offer excellent protection and durability. These nets are perfect for creating a mosquito-free environment in both residential and commercial spaces."
    },
    {
      "title": "Eco-Friendly Mosquito Nets",
      "description": "We offer eco-friendly mosquito nets made from sustainable materials, providing an environmentally responsible way to protect your home or office from mosquitoes. These nets are non-toxic, safe for families, and ideal for those seeking eco-conscious solutions."
    },
    {
      "title": "Installation of Aluminium Window Nets",
      "description": "Our expert team specializes in the installation of aluminium window nets, ensuring a perfect fit for any window type. We take care of every detail to guarantee that your windows are mosquito-proof while maintaining a clean, attractive look."
    },
    {
      "title": "Mosquito Netting Services in Pune",
      "description": "Anjali Enterprises is a trusted provider of mosquito netting services in Pune. We offer a range of mosquito-proof solutions, including aluminium nets, that are designed to suit your needs and keep your space pest-free."
    },
    {
      "title": "Durable Mosquito Netting",
      "description": "Our aluminium mosquito nets are designed for durability, offering long-lasting protection against mosquitoes and insects. They are resistant to wear and tear, ensuring that your space stays protected for years."
    },
    {
      "title": "Mesh Screen Windows",
      "description": "We provide high-quality mesh screen windows that effectively keep mosquitoes and other pests out while allowing for ventilation and natural light. These screens are ideal for maintaining a comfortable and pest-free living or working environment."
    },
    {
      "title": "Anjali Enterprises Contact Number:",
      "description": "Contact Anjali Enterprises at +91 8793220265 for reliable and high-quality aluminium mosquito net installation services. We specialize in providing durable, easy-to-install aluminium mosquito nets for windows and doors, ensuring protection from insects while maintaining ventilation and aesthetic appeal. Get in touch for expert installation and professional service. Serving Pune with top-notch aluminium mosquito net solutions for a comfortable and insect-free environment."
    }
  ],
  "tableData": [
    ["- Aluminium Mosquito Net Installation", "- Custom Mosquito Nets for Windows"],
    ["- Mosquito-Proof Solutions", "- High-Quality Aluminium Mesh Nets"],
    ["- Best Mosquito Net for Windows", "- Aluminium Mosquito Net for Homes and Offices"],
    ["- Eco-Friendly Mosquito Nets", "- Installation of Aluminium Window Nets"],
    ["- Mosquito Netting Services in Pune", "- Durable Mosquito Netting"],
    ["- Mesh Screen Windows", "- Anjali Enterprises Contact Number:"]
  ],


   "whychoose": [
  {
    "WhyChooseheading": "High-Quality Aluminium Mosquito Nets",
    "WhyChoosedescription": "At Anjali Enterprises, we specialize in providing premium aluminium mosquito nets designed to offer superior protection against insects while maintaining optimal airflow and visibility. Our mosquito nets are perfect for both residential and commercial properties, offering a practical and effective solution to keep pests out while ensuring a comfortable living or working environment."
  },
  {
    "WhyChooseheading": "Durable and Long-Lasting",
    "WhyChoosedescription": "Our aluminium mosquito nets are made from high-quality materials that ensure durability and longevity. Rust-resistant and weatherproof, they are built to withstand the elements and provide a long-lasting solution to insect problems. The robust aluminium frame ensures that the net remains intact and functional for years to come, giving you peace of mind with minimal maintenance."
  },
  {
    "WhyChooseheading": "Custom Fit and Easy Installation",
    "WhyChoosedescription": "We understand that every property has unique window and door dimensions. That's why we offer fully customizable aluminium mosquito nets that are designed to perfectly fit your openings. Our expert team ensures quick and hassle-free installation, giving you a seamless and neat finish with minimal disruption to your daily routine."
  },
  {
    "WhyChooseheading": "Maximum Protection with Minimal Impact",
    "WhyChoosedescription": "Our aluminium mosquito nets are engineered to provide maximum protection from mosquitoes, flies, and other insects without compromising your comfort. These nets do not obstruct your view or restrict airflow, allowing you to enjoy fresh air and natural light while keeping unwanted pests at bay. Enjoy the outdoors without worrying about insects invading your space."
  },
  {
    "WhyChooseheading": "Low Maintenance",
    "WhyChoosedescription": "Our aluminium mosquito nets require minimal maintenance to keep them in top condition. They are easy to clean, durable, and resistant to wear and tear, ensuring that they stay functional for years. The sturdy aluminium frame ensures that the net remains intact, and the design makes it simple to maintain without hassle or extra cost."
  },
  {
    "WhyChooseheading": "Sleek and Modern Design",
    "WhyChoosedescription": "The slim and stylish aluminium frames offer a modern, minimalistic look that complements your existing window and door designs. Our mosquito nets are available in a variety of sizes and finishes to suit your specific aesthetic preferences and functional needs, enhancing the overall appeal of your space while providing excellent protection."
  },
  {
    "WhyChooseheading": "Energy Efficient",
    "WhyChoosedescription": "With our aluminium mosquito nets, you can enjoy the benefits of open windows and doors without compromising your comfort or energy efficiency. The nets allow for improved ventilation and natural cooling, reducing your reliance on air conditioning and helping to maintain an energy-efficient environment in your home or office."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "We offer competitive and transparent pricing for all our aluminium mosquito net installations. There are no hidden charges or surprise costs, so you can enjoy peace of mind knowing that you’re getting great value for your money. Our affordable solutions provide high-quality products and reliable service, ensuring an excellent return on investment."
  },
  {
    "WhyChooseheading": "Customer Satisfaction",
    "WhyChoosedescription": "At Anjali Enterprises, customer satisfaction is our priority. We go the extra mile to ensure that you are completely happy with your mosquito net solution. Our reliability, exceptional customer service, and high-quality products have earned us the trust of many satisfied clients, and we strive to maintain this standard with every project."
  }
]



  }

  const faqData = [
    {
      question: "What are the benefits of installing aluminium mosquito nets?",
      answer: "Aluminium mosquito nets provide protection against insects, such as mosquitoes and flies, while allowing for good airflow and visibility. They are durable, rust-resistant, and easy to maintain, offering a long-lasting solution for pest control."
    },
    {
      question: "Can aluminium mosquito nets be customized?",
      answer: "Yes, we offer fully customizable aluminium mosquito nets to fit any window, door, or opening. Our team ensures that each net is tailored to the specific size and design requirements of your space."
    },
    {
      question: "How do I clean and maintain my aluminium mosquito net?",
      answer: "Aluminium mosquito nets require minimal maintenance. You can easily clean them by wiping them down with a damp cloth or washing them gently with soap and water. The aluminium frame is rust-resistant, ensuring that the net stays intact over time."
    },
    {
      question: "Are aluminium mosquito nets effective in blocking all insects?",
      answer: "Yes, our aluminium mosquito nets are designed to block mosquitoes, flies, and other common insects, providing reliable protection from pests without affecting the airflow or view."
    },
    {
      question: "How long does it take to install aluminium mosquito nets?",
      answer: "Installation time depends on the size and number of windows or doors. However, our team is highly efficient, and we aim to complete the installation quickly and with minimal disruption to your space."
    },
    {
      question: "Are aluminium mosquito nets energy-efficient?",
      answer: "Yes, aluminium mosquito nets help to improve the energy efficiency of your home or office by allowing you to keep windows and doors open for ventilation without worrying about insects entering, reducing the need for air conditioning or artificial cooling."
    },
    {
      question: "Can aluminium mosquito nets be installed in existing buildings?",
      answer: "Yes, we specialize in retrofitting aluminium mosquito nets into existing windows and doors. Our team ensures a perfect fit, no matter the type of building or window design."
    },
    {
      question: "Are the aluminium mosquito nets visible from a distance?",
      answer: "No, the design of our aluminium mosquito nets ensures that they are discreet and blend well with your window or door frames. The nets are transparent, providing an unobstructed view from inside while keeping pests out."
    },
    {
      question: "How do I get a quote for aluminium mosquito net installation?",
      answer: "Contact us for a free consultation, and we will provide a detailed, transparent quote based on the number of nets required, the size of the openings, and any customization options you may need."
    },
    {
      question: "Why should I choose Anjali Enterprises for aluminium mosquito nets?",
      answer: "Anjali Enterprises offers high-quality, durable, and customizable aluminium mosquito nets. Our expert team ensures professional installation, and we are committed to delivering excellent customer service and satisfaction."
    }
  ];
  
  const testimonials = [
    {
      name: "Mr. Rajesh Kumar",
      text: "We installed aluminium mosquito nets in our home, and the difference is amazing. No more mosquitoes, and we can enjoy the fresh air with open windows. The installation was quick and easy, and the nets look great!"
    },
    {
      name: "Ms. Anita Mehta",
      text: "As a business owner, I needed a solution to keep the pests out without compromising ventilation. Anjali Enterprises provided the perfect aluminium mosquito nets that work beautifully in our office space. Great service!"
    }
  ];
  



  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>{testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: " Anjali Enterprises Contact Information:",
    contactNumbers: [
      "+91 8793220265",

    ],
    email: "info@anjalienterprisesindia.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "All Types of Aluminium Glass Office Partition",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "All Types of Toughened Glass Work",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Door Partition",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "ACP Cladding Panel Installation",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Aluminium Glass Window",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Soundproof Glass Window",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Aluminium Mosquito Net",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bird Net Installation",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Invisible Grill Installation",
    },
    {
      place: "/images/keyword/10.jpg",
      text: " MS Fabrication Door",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "MS Fabrication Shade",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "MS Fabrication Grill",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "MS Fabrication Slide Door ",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "MS Fabrication Industrial Shade",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "All Types of Industrial Fabrication Work",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "All Types of Furniture Work",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "All Types of Industrial Work",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "All Types of Home Renovation Work",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "All Types of Painting Work",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Foil Ceiling Work",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Electrical Work",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Puff Panel Room ",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "PCC Work & Epoxy Flooring Work ",
    },
  ];


  const images = [
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },

  ];



  return (
    <div>


<Helmet>
  <title>Contact: +91 8793220265 | Anjali Enterprises | Aluminium Mosquito Net Installation Services in Pune</title>
  <meta name="description" content="Anjali Enterprises provides aluminium mosquito net installation services in Pune, offering custom and eco-friendly mosquito-proof solutions for windows in homes and offices. Call +91 8793220265 for your mosquito netting needs." />
  <meta name="keywords" content="Aluminium Mosquito Net Installation, Custom Mosquito Nets for Windows, Mosquito-Proof Solutions, High-Quality Aluminium Mesh Nets, Best Mosquito Net for Windows, Aluminium Mosquito Net for Homes and Offices, Eco-Friendly Mosquito Nets, Installation of Aluminium Window Nets, Mosquito Netting Services Pune, Durable Mosquito Netting, Mesh Screen Windows" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8793220265 | Anjali Enterprises | Aluminium Mosquito Net Installation Services in Pune" />
  <meta property="og:description" content="Anjali Enterprises provides aluminium mosquito net installation services in Pune, offering custom and eco-friendly mosquito-proof solutions for windows in homes and offices. Call +91 8793220265 for your mosquito netting needs." />
  <meta property="og:image" content="https://anjalienterprisesindia.com/images/aluminium-mosquito-net-service.jpg" />
  <meta property="og:url" content="https://anjalienterprisesindia.com/aluminium-mosquito-net-installation" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Anjali Enterprises" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "Anjali Enterprises",
        "description": "Anjali Enterprises provides aluminium mosquito net installation services in Pune, offering custom and eco-friendly mosquito-proof solutions for windows in homes and offices. Call +91 8793220265 for your mosquito netting needs.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411057",
          "addressCountry": "IN"
        },
        "telephone": "+91-8793220265",
        "email": "info@anjalienterprisesindia.com",
        "url": "https://anjalienterprisesindia.com/aluminium-mosquito-net-installation",
        "logo": "https://anjalienterprisesindia.com/images/anjali-enterprises-logo.jpg",
        "image": "https://anjalienterprisesindia.com/images/aluminium-mosquito-net-service.jpg",
        "priceRange": "₹1500 - ₹8000",
        "offers": {
          "@type": "Offer",
          "url": "https://anjalienterprisesindia.com/aluminium-mosquito-net-installation",
          "priceCurrency": "INR",
          "price": "1500",
          "priceValidUntil": "2025-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "32"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Manish R"
            },
            "datePublished": "2024-07-25",
            "reviewBody": "The aluminium mosquito netting installation in my house was smooth and efficient. The nets are durable and have worked great for keeping insects out. Highly recommend Anjali Enterprises!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Neha J"
            },
            "datePublished": "2024-09-10",
            "reviewBody": "We got custom aluminium mosquito nets installed for our office, and the quality is fantastic. The team was professional, and the installation was quick."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Anjali Enterprises Service Area",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5195",
            "longitude": "73.8551"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://anjalienterprisesindia.com/aluminium-mosquito-net-installation"
        },
        "keywords": "Aluminium Mosquito Net Installation, Custom Mosquito Nets for Windows, Mosquito-Proof Solutions, High-Quality Aluminium Mesh Nets, Best Mosquito Net for Windows, Aluminium Mosquito Net for Homes and Offices, Eco-Friendly Mosquito Nets, Installation of Aluminium Window Nets, Mosquito Netting Services Pune, Durable Mosquito Netting, Mesh Screen Windows"
      }
    `}
  </script>
</Helmet>



      {/* Banner */}
      <div className="inner-pages-bnr">
        <img src="images/service-banner.jpg" className="img-responsive" alt="Service-banner-image" />
        <div className="banner-caption">
          <h1 className='text-white'>{cardData.keyword}</h1>
        </div>
      </div>



      <section>
        <div className="" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/7.jpg' className='img-fluid' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#24ABE2', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}

              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {/* {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))} */}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <h3 className='Colo'>Why Choose Anjali Enterprises for {cardData.keyword}  </h3>

              <div id="why-choose-section"
                className='px-2'>


                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>

              <div>
                <h3 className='Colo'>FAQs{cardData.keyword} for Anjali Enterprises</h3>
                <Accordion data={faqData} />
              </div>
              <div className=''>


                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>

              <div className='py-5'>

                <div className="contact-box borderrr py-md-3">
                  <h2>{contactData.heading}</h2>
                  <p>For inquiries, quotes, or assistance with your aluminium glass office partition needs, please contact us:</p>
                  <div className="contact-details">
                    <p><strong className=''>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5 darkcolor">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className=''>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link darkcolor">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >

              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>

                );
              })}










              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '1px solid #24ABE2',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                  color: 'white'
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#24ABE2' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8793220265 " className="d-block  text-white">+91 8793220265 </a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@anjalienterprisesindia.com" className=" text-white d-block">
                          info@anjalienterprisesindia.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i>

                            Anjali Enterprises:<br />
                            Shop No 7 Vishal Deep Residency M  <br />
                            Perk Nagar Highway, Chandan Nagar<br />
                            Vadgaon Sheri,  (Near NA Bus Stop) Pune <br />
                            Maharashtra 411014
                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <Gallery images={images} ></Gallery>

              </div>

            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Aluminiuamlmosquito;